import { createUseStyles } from 'react-jss'
import { DARK_GRAY_20, RED } from '@omnilert/components'

export default createUseStyles({
  actionItem: {
    alignItems: 'center',
    borderTop: `1px solid ${DARK_GRAY_20}`,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    lineHeight: '22px',
    padding: '18px',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  list: {
    width: '100%',
    padding: 0,
    margin: 0,
    '& li:last-child': {
      borderBottom: `1px solid ${DARK_GRAY_20}`
    }
  },
  icon: {
    stroke: 'var(--emergency-sheet__icon__stroke__color) !important',
    '&.emergency': {
      stroke: 'url(#error) !important'
    },
    '&.silent path': {
      stroke: 'var(--emergency-sheet__icon__stroke__color) !important'
    },
    left: '0',
    padding: '0 20px',
    position: 'absolute'
  },
  textContainer: {
    color: 'var(--emergency-sheet__first__child__text__color)',
    fontFamily: 'BentonSansMedium',
    fontSize: '16px',
    lineHeight: '24px',
    '&.emergency': {
      color: `${RED} !important`
    }
  }
})
